import Affiliate from "@/components/landing/home/Affiliate";
import AppDownload from "@/components/landing/home/AppDownload";
import Banner from "@/components/landing/home/Banner";
import CallToAction from "@/components/landing/home/CallToAction";
import Customers from "@/components/landing/home/Customers";
import Faqs from "@/components/landing/home/Faqs";
import Features from "@/components/landing/home/Features";
import HowItWorks from "@/components/landing/home/HowItWorks";
import Payment from "@/components/landing/home/Payment";
import WhyChooseUs from "@/components/landing/home/WhyChooseUs";

export default function Home() {
  return (
    <main className="overflow-x-hidden">
      {/* Banner section */}
      <Banner />

      {/* Features section */}
      <Features />

      {/* Customers section */}
      <Customers />

      {/* Why Choose Us section */}
      <WhyChooseUs />

      {/* Affiliate section */}
      <Affiliate />

      {/* Payment section */}
      <Payment />

      {/* How It Works section */}
      <HowItWorks />

      {/* App Download section */}
      <AppDownload />

      {/* Faqs section */}
      <Faqs />

      {/* Call To Action section */}
      <CallToAction />
    </main>
  );
}
